import { render, staticRenderFns } from "./AgentBusiness.vue?vue&type=template&id=4f2ba407&scoped=true"
import script from "./AgentBusiness.vue?vue&type=script&lang=js"
export * from "./AgentBusiness.vue?vue&type=script&lang=js"
import style0 from "./AgentBusiness.vue?vue&type=style&index=0&id=4f2ba407&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ba407",
  null
  
)

export default component.exports